import React from "react";
import { CssBaseline, Box } from "@mui/material";
import AppTheme from "../../styles/AppTheme";
import ZabihatDates from "../../pages/zabihat/ZabihatDates";

const ZabihatDashboard = ({ year }) => {
  return (
    <AppTheme>
      <CssBaseline />
      <Box sx={{ width: "100%" }}>
        <ZabihatDates embedded year={year} />
      </Box>
    </AppTheme>
  );
};

export default ZabihatDashboard;
